import React from "react";
import { Switch, Route } from "react-router-dom";

import Home from "./pages/Home";
import Applications from "./pages/snapshotdatamanagement/Applications";
import ApplicationDetails from "./pages/snapshotdatamanagement/ApplicationDetails";
import CobrandConfig from "./pages/snapshotdatamanagement/CobrandConfig";
import Webhooks from "./pages/webhookmanagement/Webhooks";
import WebhookDetails from "./pages/webhookmanagement/WebhookDetails";
import Reports from "./pages/reportsmanagement/reports";
import ReportsView from "./pages/reportsmanagement/reportsView";
import ReportJob from "./pages/reportsmanagement/reportJob";
import PrintView from "./pages/reportsmanagement/printView";
import ReqOtp from "./pages/loginmanagement/reqotp";
import ChangePassword from "./pages/loginmanagement/ChangePassword";
import Users from "./pages/usermanagement/users";
import CreateUser from "./pages/usermanagement/createUser";
import Applicants from "./pages/usermanagement/lender/Applicants";
import CreateApplicant from "./pages/usermanagement/lender/CreateApplicant";
import SelectCobrand from "./pages/cobrandselection/Cobrands";
import VerifyOtp from "./pages/loginmanagement/verifyotp";

import Unauthorized from "./pages/errors/Unauthorized";
import NotFound from "./pages/errors/NotFound";

import Navbar from "./components/Navbar";

function Routes(props) {
  var user = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : {};
  return (
    <React.Fragment>
      <Switch>
        <Route
          exact
          path="/"
          render={() => (
            <React.Fragment>
              <Home />
            </React.Fragment>
          )}
        />
        <ProtectedRoute
          acl="VW_SNP_MGMT"
          exact
          path="/applications/:cobrandId"
          component={Applications}
        />
        <ProtectedRoute
          acl="VW_SNP_MGMT"
          exact
          path="/applications/:cobrandId/:applicationId"
          component={ApplicationDetails}
        />
        <ProtectedRoute
          acl="VW_CFG"
          exact
          path="/config/:cobrandId"
          component={CobrandConfig}
        />
        <ProtectedRoute
          acl="VW_WHK"
          exact
          path="/webhooks/:cobrandId"
          component={Webhooks}
        />
        <ProtectedRoute
          acl="VW_WHK"
          exact
          path="/webhooks/:cobrandId/:webhookId"
          component={WebhookDetails}
        />
        <ProtectedRoute
          acl="VW_RPT_MGMT"
          exact
          path="/reports/:cobrandId"
          component={Reports}
        />
        <ProtectedRoute
          acl="VW_RPT_MGMT"
          exact
          path="/reportsView/:jobId/:reportId"
          component={ReportsView}
        />
        <ProtectedRoute
          acl="VW_RPT_MGMT"
          exact
          path="/reportJob/:jobId"
          component={ReportJob}
        />
        <ProtectedRoute
          acl="VW_RPT_MGMT"
          exact
          path="/printView"
          component={PrintView}
        />
        <Route
          path="/logout"
          render={() => {
            localStorage.clear();
            window.location.href = "/";
          }}
        />
        <ProtectedRoute
          acl="VW_PROFILE_MGMT"
          exact
          path="/changePassword"
          component={ChangePassword}
        />
        <Route path="/manageLogin" component={ReqOtp} />
        <Route path="/verifyOTP" component={VerifyOtp} />
        <ProtectedRoute
          acl="VW_USER_MGMT"
          exact
          path="/userMgmt/:cobrandId"
          component={Users}
        />
        <ProtectedRoute
          acl="VW_USER_MGMT"
          exact
          path="/userMgmt/edit_1/:cobrandId"
          component={CreateUser}
        />
        <ProtectedRoute
          acl="VW_BWR_MGMT"
          exact
          path="/applicantMgmt/:cobrandId"
          component={Applicants}
        />
        <ProtectedRoute
          acl="VW_BWR_MGMT"
          exact
          path="/applicantMgmt/edit_1/:cobrandId"
          component={CreateApplicant}
        />
        {/* Remove dependency on ACL */}
        <ProtectedRoute
          acl="VW_USER_MGMT"
          exact
          path="/selectCobrand"
          component={SelectCobrand}
        />
        <Route
          render={() => (
            <React.Fragment>
              <Navbar displayLinks={true} />
              <NotFound />
            </React.Fragment>
          )}
        />
      </Switch>
    </React.Fragment>
  );
}

function ProtectedRoute({ component: Component, ...rest }) {
  var user = localStorage.getItem("userData")
    ? JSON.parse(localStorage.getItem("userData"))
    : {};
  var acls = user.acls ? user.acls : [];
  var tempPassword = user.authentication
    ? user.authentication.tempPassword
    : false;
  return (
    <Route
      {...rest}
      render={props =>
        acls.includes(rest.acl) && !tempPassword ? (
          <React.Fragment>
            <Navbar displayLinks={true} />
            <Component {...props} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Navbar displayLinks={false} />
            <Unauthorized />
          </React.Fragment>
        )
      }
    />
  );
}

export default Routes;
